import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation, ElementRef } from '@angular/core';
import { ComponentDefinition } from '@formbird/types';
import { ChangedDocumentService } from 'formbird-services';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import { DropDownConfigService } from '../../../../formbird-sc-shared/src/lib/drop-down-config.service';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

// extend the ComponentDefinition type with the additional fields for the component
interface DropDownOpenComponentDefinition extends ComponentDefinition {
  dropDownList?: any;
  configObjectName: any;
}

@Component({
  templateUrl: './drop-down-open.component.html',
  styleUrls: ['./drop-down-open.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropDownOpenComponent extends AbstractComponent<DropDownOpenComponentDefinition> implements OnInit {

  @ViewChild('input', {static: false}) input: ElementRef<HTMLInputElement>;

  selectedOptions;
  selectTextSearch;
  oldSelectedOption
  oldSearchValue = '';
  changedSearchValue = '';
  filteredOptions;
  formControl = new FormControl('')

  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected cdr: ChangeDetectorRef,
    private dropDownConfigService: DropDownConfigService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);
  }

  async ngOnInit() {
    super.ngOnInit();

    this.selectedOptions = [];
    if (!(typeof this.componentDefinition.dropDownList === 'undefined' || this.componentDefinition.dropDownList === null)) {
      this.selectedOptions = [...this.componentDefinition.dropDownList];
    }

    if (this.fieldValue) {
      if (this.selectedOptions.indexOf(this.fieldValue) === -1) {
        this.selectedOptions.unshift(this.fieldValue);
      }
    }

    if (this.componentDefinition.configObjectName) {
      try {
        const result = await this.dropDownConfigService.searchConfigList(
          this.componentDefinition.configObjectName,
          this.fieldName,
          this.template.documentId
        );

        if (result && result.length) {
          this.selectedOptions = result;
        }

        this.cdr.detectChanges();
      } catch(err) {
        console.error(err);
      }
    }
    this.filteredOptions = this.selectedOptions;
  }

  fnLoadItemData(searchValue) {
    this.selectedOptions = this.removeValueInArray(this.selectedOptions, this.oldSearchValue, null);
    if (searchValue) {
      searchValue = searchValue.trim();
      this.selectTextSearch = searchValue;
      if (!this.checkValueInArray(searchValue, this.selectedOptions)) {
        this.selectedOptions = [searchValue, ...this.selectedOptions];
        this.filteredOptions = this.selectedOptions.filter(option => option.toLowerCase().includes(searchValue))
        console.log('fnLoadItemData, this.selectedOptions = ' + this.selectedOptions
        + ', searchValue = ' + searchValue);
        if (this.oldSearchValue !== searchValue) {
          this.oldSearchValue = searchValue;
        }
        this.changedSearchValue = searchValue;
        this.valueChanged(this.changedSearchValue);
      } else if (this.oldSearchValue !== '') {
        this.selectedOptions = [...this.selectedOptions];
      }

    }
    this.selectTextSearch = '';
    this.oldSearchValue = '';
  }

  keyPressUp(event) {
    if (event.key === 'Enter' || event.key === 'Tab' || event.key === 'Shift') {
      if (event.key === 'Enter') {
        this.fnLoadItemData(this.selectTextSearch);
      } else {
        event.preventDefault();
        return;
      }
    }

    let searchTerm = this.input.nativeElement.value;
    let searchValue = '';
    this.selectedOptions = this.removeValueInArray(this.selectedOptions, this.oldSearchValue, null);
    if (searchTerm) {
      searchTerm = searchTerm.trim();
      searchValue = searchTerm;
      this.selectTextSearch = searchTerm;
      if (!this.checkValueInArray(searchTerm, this.selectedOptions)) {
        this.selectedOptions = [searchTerm, ...this.selectedOptions];
        this.filteredOptions = this.selectedOptions.filter(option => option.toLowerCase().includes(searchValue))
        console.log('keyPressUp, this.selectedOptions = ' + this.selectedOptions
        + ', searchTerm = ' + searchTerm);
        if (this.oldSearchValue !== searchTerm) {
          this.oldSearchValue = searchTerm;
          searchValue = this.oldSearchValue;
        }
      }
      this.changedSearchValue = searchValue;
    }
    // console.log('key press up, this.selectedOptions = ' + JSON.stringify(this.selectedOptions));
  }

  keyDown(event){
    if ((event.key === 'Backspace' || event.key === 'Delete') && (event.ctrlKey || event.metaKey) ) {
      const markedEl = document.querySelector('.mat-option.mat-active');
      const item = markedEl.getAttribute('ng-reflect-value');
      this.removeOption( item );
    }
  }

  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    const pastedData = clipboardData.getData('text');
    this.fnLoadItemData(pastedData);
  }
  onBlur(event) {
    console.log('onBlur, this.changedSearchValue = ' + this.changedSearchValue);
    if(this.changedSearchValue){
      if (this.formControl) {
        this.formControl.patchValue(this.changedSearchValue, { emitEvent: false, onlySelf: true });
      }

      if (this.selectedOptions.indexOf(this.changedSearchValue) === -1) {
        this.selectedOptions = [...this.selectedOptions, this.changedSearchValue];
      }
      this.fnLoadItemData(this.changedSearchValue);
    }else{
      this.formControl.setValue(this.oldSelectedOption)
    }
    this.changedSearchValue = '';
  }

  onSelect(event: MatAutocompleteSelectedEvent) {
    console.log('onSelect, val = ', event.option.value);
    this.changedSearchValue = event.option.value
    this.input.nativeElement.blur()
  }


  onFieldValueChanged(fieldValue) {
    if (this.fieldValue === fieldValue) {
      return;
    }
    this.fieldValue = fieldValue;
    if (this.formControl) {
      this.formControl.patchValue(this.fieldValue, { emitEvent: false, onlySelf: true });
    }

    if (fieldValue && this.selectedOptions.indexOf(fieldValue) === -1) {
      this.selectedOptions = [...this.selectedOptions, fieldValue];
    }

    this.fnLoadItemData(fieldValue);

    this.detectChanges();
  }

  checkValueInArray(value, arr) {
    let isFound = false;
    for (let i = 0; i < arr.length; i++) {
      const name = arr[i];
      if (name.toLowerCase() === value.toLowerCase()) {
          isFound = true;
          break;
      }
    }
    console.log('checkValueInArray, isFound = ' + isFound + ', value = ' + value);
    return isFound;
  }
  removeValueInArray(arr, elem, all) {
    for (let i = arr.length - 1; i >= 0; i--) {
      if (arr[i] === elem) {
        arr.splice(i, 1);
        if (!all) {
          break;
        }
      }
    }
    return arr;
  }
  isEmptyObject(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  showToolTip(tooltip: any, formFieldContainer: any, labelContainer: any) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: any) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }

   onClick() {
    if ( !this.disabled) {
        // set text to input to execute search
        this.oldSelectedOption = (this.formControl.value)? this.formControl.value: this.oldSelectedOption;
        this.formControl.setValue('');
        this.filteredOptions = this.selectedOptions
        this.formControl.markAllAsTouched();
    }
  }
  clickInput(input: HTMLInputElement, chipsWrapper) {
      try {
        this.input.nativeElement.focus();
        this.onClick();
      } catch (err) {
        console.log(err);
      }
  }



  removeHandler( event, item ){
    this.removeOption( item );
    event.stopPropagation();
  }

  removeOption( item ){
    if(this.componentDefinition.dropDownList.indexOf(item) !== -1){
      return;
    }

    if( this.formControl.value === item ){
      this.fieldValue = undefined;
      // this.input.handleClearClick();

      if (this.formControl) {
        this.formControl.patchValue(this.fieldValue, { emitEvent: false, onlySelf: true });
      }

      this.changedSearchValue = '';
      this.selectTextSearch = '';
      this.oldSearchValue = '';
      this.oldSelectedOption = '';

    }
    this.selectedOptions = [...this.removeValueInArray(this.selectedOptions, item, null)];
    this.filteredOptions = this.selectedOptions;
  }
}
